import { GhostButton, Text, useColors } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { createRef, useEffect, useState } from "react";

import { useMenuStyles } from "./styles";

type MenuProps = {
  label: string;
  children: React.ReactNode;
};

export function Menu({ label, children }: MenuProps) {
  const styles = useMenuStyles();
  const [isOpen, setIsOpen] = useState<boolean>();
  const ref = createRef<HTMLDivElement>();
  const colors = useColors();

  useEffect(() => {
    document.addEventListener("click", () => setIsOpen(false));
    return () => {
      document.removeEventListener("click", () => setIsOpen(false));
    };
  }, [isOpen]);

  return (
    <div className={styles.container}>
      <GhostButton
        onPress={() => setIsOpen((prev) => !prev)}
        size="medium"
        rightIcon="expand_more"
      >
        <Text color="text-weak">{label}</Text>
      </GhostButton>

      {isOpen && (
        <div
          ref={ref}
          className={css(styles.popover, {
            background: colors["surface-overlay"],
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}
